import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import React,{ useState } from "react";
import PropTypes from "prop-types";
import empty_light from "../../frontend/assets/img/spot-illustrations/36.png";
import empty_dark from "../../frontend/assets/img/spot-illustrations/36_2.png";

export default function Table({
  data,
  columns,
  filtering,
  setFiltering,
  handleRowClick,
  classNameTable,
}) {
  const [sorting, setSorting] = useState([]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: { sorting, globalFilter: filtering },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  const pageIndex = table.getState().pagination.pageIndex;
  const pageSize = table.getState().pagination.pageSize;
  const totalRows = data.length;
  const totalPages = table.getPageCount();

  const startItem = pageIndex * pageSize + 1;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <>
      <table className={classNameTable}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  className={header.column.columnDef.className}
                  style={{ width: header.column.columnDef.width }}
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                  {header.column.getIsSorted() === "asc"
                    ? "⬆️"
                    : header.column.getIsSorted() === "desc"
                    ? "⬇️"
                    : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="list" id="order-table-body">
          {table.getRowModel().rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-5">
                <div className="d-flex flex-column align-items-center">
                  <img
                    className="d-dark-none mt-2 position-sticky"
                    src={empty_light}
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.4",
                    }}
                  />
                  <img
                    className="d-light-none mt-2 position-sticky"
                    src={empty_dark}
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.4",
                    }}
                  />
                  <p className="fw-bold mb-2" style={{ opacity: "0.6" }}>
                    No se encontraron registros
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            table.getRowModel().rows.map((row) => (
              <tr
                key={row.id}
                className={`hover-actions-trigger btn-reveal-trigger position-static ${
                  row.original.anulado === "S"
                    ? "opacity-25 bg-body-tertiary"
                    : ""
                }`}
                onClick={() =>
                  row.original.anulado !== "S" && handleRowClick(row.original)
                }
                style={{
                  cursor:
                    row.original.anulado !== "S" ? "pointer" : "",
                }}
              >
                {row.getVisibleCells().map((cell) => (
                 <React.Fragment key={cell.id}>
                  {cell.column.columnDef.cell ? cell.column.columnDef.cell(cell.getContext()) : cell.getValue()}
                  </React.Fragment> 
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-4 mb-3 position-relative">
        <p className="mb-0 fs-9">
          <span className="d-none d-sm-inline-block">
            {startItem} a {endItem}
            <span className="text-body-tertiary"> Elementos de </span>
            {totalRows}
          </span>
        </p>

        <div className="d-flex position-absolute start-50 translate-middle-x">
          <button
            className="page-link btn btn-subtle-secondary me-1 mb-1"
            type="button"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="fas fa-angle-double-left"></span>
          </button>
          <button
            className="page-link btn btn-subtle-primary me-1 mb-1"
            type="button"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="fas fa-chevron-left"></span>
          </button>
          <button
            className="page-link btn btn-subtle-primary me-1 mb-1"
            type="button"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            <span className="fas fa-chevron-right"></span>
          </button>
          <button
            className="page-link btn btn-subtle-secondary me-1 mb-1"
            type="button"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            <span className="fas fa-angle-double-right"></span>
          </button>
        </div>

        <p className="mb-0 fs-9">
          Pagina {pageIndex + 1} de {totalPages}
        </p>
      </div>
    </>
  );
}

Table.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  filtering: PropTypes.string,
  setFiltering: PropTypes.func,
  handleRowClick: PropTypes.func,
  classNameTable: PropTypes.string,
};
